import { PailOffOutlineIcon } from './PailOffOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 896E500B-797D-4687-917C-063906BB503F
 * name pail-off-outline
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pail-off-outline.svg
 * tags
 */
export const BucketOffOutlineIcon = PailOffOutlineIcon;
export default BucketOffOutlineIcon